import React, {useState} from 'react';
import { Button, Grid, TextField, Typography, withStyles } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import {forgotPassword, changeForgottonPassword} from '../../store/auth';
import styles from './styles';
import { Redirect } from 'react-router-dom';

function ForgotPassword(props) {
  const dispatch = useDispatch();
  const {classes} = props;
  const [values, setValues] = useState({
    email: '',
    emailSubmitted: false,
    slug: '',
    passwordOne: '',
    passwordTwo: '',
    passwordError: false,
    errorMessage: ''
  });

  const passwordChanged = useSelector(state => state.entities.auth.redirectToLogin);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleEmailSubmit = () => {
    setValues({...values, emailSubmitted: true});
    dispatch(forgotPassword(values.email));
  }

  const handlePasswordChange = () => {
    if (values.passwordOne !== values.passwordTwo) {
      setValues({...values, passwordError: true, errorMessage: 'Passwords must match'});
      return;
    }

    setValues({...values, passwordError: false, errorMessage: ''});
    dispatch(changeForgottonPassword({email: values.email, slug: values.slug, password: values.passwordOne}))
  }

  if (passwordChanged) return <Redirect to="/login"/>;
  return (
    <Grid container>
      <Grid item xs={12} className={classes.inputMargin}>
        <Typography>A verification code will be sent to your email after hitting submit.</Typography>
      </Grid>
      <Grid item xs={12} className={classes.inputMargin}>
        <TextField disabled={values.emailSubmitted} variant='outlined' onChange={handleChange('email')} label="Email" value={values.email}/>
      </Grid>
      <Grid item xs={12} className={classes.blockA}>
        <Button variant='contained' color='primary' onClick={handleEmailSubmit}>Send Code</Button>
      </Grid>
      {values.emailSubmitted ? 
      <React.Fragment>
        <Grid item xs={12} className={classes.inputMargin}>
          <TextField  variant='outlined' onChange={handleChange('slug')} label="Verification Code" value={values.slug}/>
        </Grid>
        <Grid item xs={12} className={classes.inputMargin}>
          <TextField 
            error={values.passwordError} 
            type='password' 
            helperText={values.errorMessage} 
            variant='outlined' 
            onChange={handleChange('passwordOne')} 
            label="Password" 
            value={values.passwordOne}
          />
        </Grid>
        <Grid item xs={12} className={classes.inputMargin}>
          <TextField 
            error={values.passwordError} 
            type='password' 
            helperText={values.errorMessage} 
            variant='outlined' 
            onChange={handleChange('passwordTwo')} 
            label="Repeat Password"
            value={values.passwordTwo}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant='contained' color='primary' onClick={handlePasswordChange}>Submit</Button>
        </Grid>
      </React.Fragment>
      : ``}
    </Grid>
  );
}

export default withStyles(styles)(ForgotPassword);